import { render, staticRenderFns } from "./AsignaCup.vue?vue&type=template&id=5d1af8a9"
import script from "./AsignaCup.vue?vue&type=script&lang=js"
export * from "./AsignaCup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports